import axios from 'axios';
import isLoggedIn from './isLoggedIn';

let token = "";
if(typeof window != undefined){
    token = window.localStorage?.getItem("devToken");
}

const getToken = (token, user) => {
    return (user.maxRole == 'Owner' ? 'ey5' : 'ey1') + token;
}

const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
if(isLoggedIn){
    headers.Authorization = `Thekaa  ${token}`
}
const axiosClient = axios.create({
    headers,
});

export const setTokenInLocalStorage = (token, user) => {
    const tokenStore = getToken(token, user);
    window.localStorage.setItem("devToken", tokenStore);
}

export default axiosClient;